module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [(_vm.updateRequiredMessage) ? _c('div', {
    staticClass: "flash-message text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-info'
  }, [_vm._v("\n          " + _vm._s(_vm.updateRequiredMessage) + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box box-primary profile_wrapper"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('li', {
    class: _vm.detailsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#details"
    }
  }, [_vm._v("Details")])]), _vm._v(" "), _c('li', {
    class: _vm.settingsActive
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#settings"
    }
  }, [_vm._v("Settings")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content profile_wrapper_paddi"
  }, [_c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.detailsActive,
    attrs: {
      "id": "details"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.firstName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProfile.firstName),
      expression: "newProfile.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "name": "firstName",
      "required": "",
      "placeholder": "First Name",
      "type": "text",
      "pattern": "[a-zA-Z\\sand mod]{0,25}"
    },
    domProps: {
      "value": (_vm.newProfile.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProfile, "firstName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "firstName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                            This is a required field\n                          ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                            Alphabets are allowed.\n                          ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.lastName),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProfile.lastName),
      expression: "newProfile.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "name": "lastName",
      "placeholder": "Last Name",
      "type": "text",
      "pattern": "[a-zA-Z\\sand mod]{0,25}"
    },
    domProps: {
      "value": (_vm.newProfile.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProfile, "lastName", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "lastName",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                            Alphabets are allowed.\n                          ")])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.email),
    attrs: {
      "auto-label": "",
      "custom": {
        email: _vm.emailValidator
      }
    }
  }, [_c('label', [_vm._v("Email ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newProfile.email),
      expression: "newProfile.email"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "maxlength": "50",
      "type": "email",
      "name": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.newProfile.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newProfile, "email", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "email",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "email"
    },
    slot: "email"
  }, [_vm._v("Email is invalid")])])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
    staticClass: "btn colorbtn",
    attrs: {
      "type": "submit",
      "disabled": !_vm.formstate.$dirty || _vm.formstate.$invalid
    },
    on: {
      "click": _vm.updateProfile
    }
  }, [_vm._v("\n                      Update Profile\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "py-2 text-center row",
    staticStyle: {
      "margin-top": "10px"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    class: _vm.settingsActive,
    attrs: {
      "id": "settings"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-4"
  }, [_c('vue-form', {
    staticClass: "row",
    attrs: {
      "state": _vm.passwordFormstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.updatePassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.passwordFormstate.newPassword),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("New Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "password",
      "maxlength": "25",
      "name": "newPassword",
      "required": "",
      "placeholder": "New Password",
      "type": "password",
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*#?&])[A-Za-z\\d@$#!%*?&]{8,}$"
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "newPassword",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                          New Password is a required field\n                        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                          Password should have at least one uppercase letter,\n                          one lowercase letter, one number and one special\n                          character. ( eg: Xyz@1234 )\n                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.passwordFormstate.confirmPassword),
    attrs: {
      "auto-label": ""
    }
  }, [_c('label', [_vm._v("Confirm Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "maxlength": "25",
      "id": "passwordVerify",
      "name": "confirmPassword",
      "required": "",
      "placeholder": "Confirm Password",
      "type": "password",
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!#%*?&])[A-Za-z\\d@$!%#*?&]{8,}$"
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "confirmPassword",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("\n                          Confirm Password is a required field\n                        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "pattern"
    },
    slot: "pattern"
  }, [_vm._v("\n                          Password should have at least one uppercase letter,\n                          one lowercase letter, one number and one special\n                          character. ( eg: Xyz@1234 )\n                        ")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('input', {
    attrs: {
      "type": "checkbox"
    },
    on: {
      "click": _vm.showPassword
    }
  }), _c('span', [_vm._v("Show Password")])]), _vm._v(" "), _c('div', {
    staticClass: "form-actions"
  }, [(_vm.$route.params && !_vm.$route.params._id) ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.passwordFormstate.$dirty && _vm.passwordFormstate.$valid)
    }
  }, [_vm._v("\n                      Update Password\n                    ")]) : _vm._e()])])], 1)])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bc84794"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/profile/Profile.vue
// module id = 2367
// module chunks = 1